import automaticOptimizationModule from "./automaticOptimizationModule"
// import tdnSpecification from "../r2/tdnSpecification.json"
import genericActionColumnButtons from "../search/genericActionColumnButtons.html"
import server from "../server"
import arrays from "../../bower_components/front-end-web-commons/app/arrays/arrays"

automaticOptimizationModule.controller("automaticOptimizationControllerSearch",
    [
        "$scope",
        "$q",
        "$state",
        "$translate",
        "$window",
        "automaticOptimizationService",
        "remoteExceptionHandler",
        "loadingService",
        "messagesModal",(
            $scope,
            $q,
            $state,
            $translate,
            $window,
            automaticOptimizationService,
            remoteExceptionHandler,
            loadingService,
            messagesModal ) => {

        // $scope.tdn = tdnSpecification["automatic-optimization"]

        const paginationApi = $q.defer()
        let filterPatch = []

        $scope.filterServiceUrl = server.getRelativeUrl("automaticOptimization")


        $scope.tableOptions = {
            records: [],
            columns: [],
            pagination: {
                onPaginate: (firstResult, maxResults) => {
                    return loadingService(automaticOptimizationService.findAutomaticOptimizationConfig(filterPatch, firstResult, maxResults)
                        .then((response) => {
                            response.result = response.result[0].children
                            $scope.tableOptions.columns = getColumns()
                            mapChildrenProperties(response.result)
                            return response
                        }))
                }
            },
            onRegisterPagination: function (api) {
                paginationApi.resolve(api)
            }
        }

        function getColumns() {
            return [{
                width: "120px",
                cell: {
                    template: genericActionColumnButtons
                }
            }, {
                header: "automaticOptimization.name",
                cell: "{{record.mappedProperties['background.task.config.param.name'].value}}",
                cellName: "name",
            }, {
                header: "automaticOptimization.user",
                cell: "{{record.mappedProperties['background.task.config.param.userSourceId'].value}}",
                cellName: "user",
            }]
        }

        function mapChildrenProperties(children) {
            arrays.each(children, function (child) {
                var map = {}
                arrays.each(child.properties, function (property) {
                    map[property.messageKey] = property
                })
                child.mappedProperties = map
            })
        }

        $scope.search = function (patch) {
            filterPatch = patch
            return paginationApi.promise.then((api) => api.seekPage(1))
        }

        $scope.editEntity = function (record) {
            $state.go("r2.editAutomaticOptimization",
                { automaticOptimizationId: record.id}
            )
        }
        $scope.copyEntity = function (record) {
            $state.go("r2.copyAutomaticOptimization",
                { automaticOptimizationId: record.id }
            )
        }

        $scope.deleteEntity = function (automaticOptimizationConfig) {
            return messagesModal.cancellable("dialog.warning", ["automaticOptimization.delete.confirm"])
                .then(function () {
                    const automaticOptimizationConfigId = automaticOptimizationConfig.id
                    return loadingService(automaticOptimizationService.deleteAutomaticOptimizationConfig(automaticOptimizationConfigId))
                        .then(function () {
                            return messagesModal("automaticOptimization.delete.ok.header", [{
                                keyBundle: "automaticOptimization.delete.ok",
                                parameters: []
                            }]).then(function () {
                                paginationApi.promise.then((api) => api.seekPage(1))
                            })
                        }).catch(remoteExceptionHandler())
                })
        }
    }])